import React from 'react'
import { IContentLoaderProps } from 'react-content-loader'
import ContentLoader from './ContentLoader'

export interface Props {
	className?: string
	style?: Record<string, unknown>
	contentLoaderProps?: IContentLoaderProps
}

const ImagePlaceholder: React.FC<Props> = (props): JSX.Element => {
	const containerStyles = {
		backgroundColor: 'var(--background-color)',
		...props.style,
	}

	return (
		<div {...props} style={containerStyles}>
			<ContentLoader {...props.contentLoaderProps}>
				<rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
			</ContentLoader>
		</div>
	)
}

export default ImagePlaceholder
